// extracted by mini-css-extract-plugin
module.exports = {"container":"payload-offer-purchased_container__zVgy1"};